<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap>
      <v-flex xs12 text-xs-center class="summaryTitle">
        <h1>Elért eredmények</h1>
      </v-flex>

      <v-flex xs12 text-xs-center>
        <v-layout row wrap>
          <v-flex xs6 sm6 text-xs-center justify-center>
            <v-layout row wrap>
              <v-flex xs8 text-xs-right>
                <img
                  :src="require('@/assets/img/footprint_mod_1.png')"
                  class="summaryImages"
                />
              </v-flex>
              <v-flex xs4 text-xs-left class="result">
                {{ stepCounter }}
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs6 sm6>
            <v-layout row wrap>
              <v-flex
                xs4
                text-xs-right
                vertical
                align-center
                fill-height
                class="result justify-content-center"
              >
                {{ lingronCounter }} / {{ maxLingron }}
              </v-flex>
              <v-flex xs8 text-xs-left>
                <img
                  :src="require('@/assets/img/new_lingron.png')"
                  class="summaryImages"
                />
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 sm12 text-xs-center justify-center>
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-chip
                  class="pa-2 mt-3 summaryPoints margin-y"
                  color="#F9F871"
                >
                  +{{ (stepCounter + lingronCounter) * multiplier }} pont
                </v-chip>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 text-xs-center>
        <img
          :src="require('@/assets/img/star_shadow.png')"
          class="summaryImages"
        />
      </v-flex>

      <v-flex xs12 text-xs-center class="summaryTitle pb-1">
        <h2 v-if="sentences.length > 2">Megtanult mondatok</h2>
        <h2 v-else>Gratulálunk!</h2>

        <v-layout row wrap>
          <v-flex
            xs12
            md10
            offset-md1
            v-for="(sentence, index) in sentences"
            v-bind:key="index"
            class="summarySentences p-3"
          >
            <transition name="fadeSlow">
              <!-- <v-card v-bind:color="sentence.color" dark v-show="sentence.show"> -->
              <v-card color="#b6d000" dark v-show="sentence.show">
                {{ sentence.sentence }}
              </v-card>
            </transition>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-spacer></v-spacer>

      <v-flex xs12 class="mt-2 align-self-center text-center">
        <v-divider></v-divider>

        <v-layout row wrap class="bgBlue">
          <v-flex xs12>
            <v-btn large dark flat @click="redirectToUrl">
              Tovább
              <v-icon right dark>keyboard_arrow_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data: function() {
    return {
      lessonId: this.$route.params.lessonId,
      stepCounter: this.$store.getters.getStepCounter,
      lingronCounter: this.$store.getters.getLingronCounter,
      maxLingron: this.$store.getters.getMaxLingron,
      sentences: "",
      multiplier: 1,
      redirectUrl: this.$store.getters.isFreeLessonRedirectUrl
    };
  },
  methods: {
    getSummaryData() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/summary/free", {
          lessonId: this.$data.lessonId
        })
        .then(response => {
          console.log("summary - resp: ", response.data);
          this.$data.sentences = response.data.sentences;
          this.$data.multiplier = response.data.multiplier;
        })
        .catch(error => {
          if (error.length > 0) {
            console.log("summary - error: ", error);
          }
        });
    },
    redirectToUrl() {
      location.replace(this.$data.redirectUrl);
    }
  },
  created: function() {
    this.getSummaryData();
  }
};
</script>
